// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section[data-v-2345f81d]{padding-top:60px;padding-bottom:60px}", ""]);
// Exports
module.exports = exports;
